import React from 'react';
import { Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import RowAddButton from '@/components/buttons/RowAddButton';
import { canEditCohort } from '../../helper';
import { updateCohortPanels } from '../../actions';
import { addCohortQuery } from '../actions';
import CohortQueryMenuItems from '../components/CohortQueryMenuItems';
import CohortQueryAccordion from './CohortQueryAccordion';
import QueryDictionariesHeader from './QueryDictionariesHeader';
import QueryDictionariesDropdown from './QueryDictionariesDropdown';

const CohortQueryMenu = ({
  code,
  category,
  queries,
  validationErrors,
  saveErrors,
  canEdit,
  queryUUID,
  isNew,
  updatePanels,
  addPanel,
}) => (
  <>
    {queries.length > 0 && !isNew && (
    <QueryDictionariesHeader code={code} category={category} queryUUID={queryUUID} />
    )}
    <Menu className="aridhia-cohort-query-menu mb-0" size="massive">
      {canEdit && (
      <Menu.Item className="p-0">
        <RowAddButton onClick={() => addPanel(code, category)} entity="query" dataPosition="right center" />
      </Menu.Item>
      )}
      <CohortQueryMenuItems
        code={code}
        category={category}
        queries={queries}
        validationErrors={validationErrors}
        saveErrors={saveErrors}
        queryUUID={queryUUID}
        canEdit={canEdit}
        updatePanels={updatePanels}
      />
      {queries.length > 0 && canEdit && (
      <QueryDictionariesDropdown category={category} code={code} queryUUID={queryUUID} />
      )}
    </Menu>
    {queries.length > 0 && (
    <CohortQueryAccordion code={code} category={category} queryUUID={queryUUID} />
    )}
  </>
);

export const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code }) => {
  const cohort = findResult(cohorts, category, code);
  return ({
    canEdit: canEditCohort(cohort, role),
    queries: cohort.queries,
    validationErrors: cohort.validationErrors,
    saveErrors: cohort.saveErrors,
    queryUUID: cohort.activeQueryUUID,
    isNew: cohort.isNew,
  });
};

const mapDispatchToProps = {
  updatePanels: updateCohortPanels,
  addPanel: addCohortQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortQueryMenu);
